import React from 'react';
import { Skeleton } from '@mui/material';
import { SkeletonBlogCard, SkeletonBlogContent } from './styles';

const SkeletonBlog = () => {
    return (
        <SkeletonBlogCard>
            <Skeleton variant="rectangular" width="100%" height={140} />
            <SkeletonBlogContent>
                {[...Array(5).keys()].map((_, index) => (
                    <Skeleton key={index} variant="text" />
                ))}
                <Skeleton width="60%" />
            </SkeletonBlogContent>
        </SkeletonBlogCard>
    );
};

export default SkeletonBlog;

